import React, { useState } from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const StyledAccordion = styled.div`
  max-height: ${props => props.isOpen ? `${props.maxHeight}px` : `64px`};
  transition: 250ms max-height ease;
  overflow: hidden;
`

const StyledButton = styled.button`
  display: flex;
  align-items: center;
  border: none;
  font-weight: 700;
  background: none;
  outline: none;
  padding: 0;
  width: 100%;
  text-align: left;
  text-transform: none;
  padding: 1rem 0;
  flex: 1;
  transition: color 150ms ease-in-out;

  ::before {
    content: "";
    display: flex;
    align-items: center;
    justify-content: center;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #4B57C5;
    margin-right: 1rem;
    margin-left: 0.5rem;
  }
`

const StyledPanel = styled.div`
  display: flex;
  flex-direction: column;
`

const Accordion = ({title, children}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [maxHeight, setMaxHeight] = useState(64)
  const toggle = () => setIsOpen(!isOpen)

  return (
    <StyledAccordion isOpen={isOpen} maxHeight={maxHeight}>
      <StyledButton onClick={toggle}>{title}</StyledButton>
      <StyledPanel ref={(ref) => {setMaxHeight(ref?.offsetHeight + 64)}}>{children}</StyledPanel>
    </StyledAccordion>
  )
}

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
}

export default Accordion
